var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4104",
    "data-name": "Rectangle 4104",
    width: 13.568,
    height: 13.565,
    fill: "#444"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9677",
    "data-name": "Group 9677",
    transform: "translate(-746 -298.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(746 298.5)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11198",
    "data-name": "Group 11198",
    transform: "translate(759 311.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11197",
    "data-name": "Group 11197",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M13.522,2.763a1.7,1.7,0,0,0-.488-.836c-.336-.329-.666-.664-1-1C11.857.756,11.681.579,11.5.408A1.581,1.581,0,0,0,9.7.179a2.233,2.233,0,0,0-.547.427Q7.366,2.391,5.579,4.179L1.42,8.336q-.446.446-.888.894a.524.524,0,0,0-.156.317c-.017.156-.033.312-.051.467-.037.331-.076.661-.113.992S.138,11.685.1,12.025q-.05.455-.1.909H0v.025a.544.544,0,0,0,.639.6q.272-.026.543-.055l1.2-.133c.517-.058,1.034-.118,1.552-.173a.634.634,0,0,0,.409-.189c.091-.095.192-.18.285-.273q.711-.708,1.42-1.417Q7.243,10.13,8.434,8.939q1.285-1.281,2.571-2.56.654-.653,1.3-1.313c.285-.289.578-.571.846-.875a1.536,1.536,0,0,0,.369-1.428m-1.043.44a.536.536,0,0,1-.155.31l-.657.661-.646.648,0,0-.322.323-.012.011-.847.849-.014.015-.3.3L6.7,9.14q-1.438,1.436-2.873,2.876a.468.468,0,0,1-.3.149c-.334.035-.667.075-1,.113-.278.031-.556.063-.834.092-.17.018-.34.032-.51.047a.237.237,0,0,1-.046-.007c.042-.363.083-.716.123-1.068.025-.217.048-.434.072-.651.028-.261.054-.523.087-.783A.218.218,0,0,1,1.487,9.8c.451-.452.9-.9,1.355-1.352L7.363,3.923h0l.989-.989h0l.173-.172,0,0,.285-.283L9.936,1.352c.044-.043.088-.086.135-.126a.516.516,0,0,1,.722,0c.127.114.246.237.367.358L12.3,2.728a.541.541,0,0,1,.18.475",
    transform: "translate(0 0.001)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M166.793,68.547l.038-.046-2.274-2.277-.108.106-.129.129h0l.989-.989,2.276,2.279c.018-.017.038-.033.056-.051Z",
    transform: "translate(-156.957 -62.536)",
    fill: "#444"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogEditIcon);
export default __webpack_public_path__ + "static/media/logEditIcon.428a8f3235f53ac8377b330ab28e0bbd.svg";
export { ForwardRef as ReactComponent };